import axios from 'axios';
import { API_URL } from './api';

/**
 * The admin user list is paginated server-side: `limit` defaults to 1000 and is
 * capped at 10000, and rows come back ordered by created_at DESC.
 *
 * So a hardcoded `?limit=1000` silently drops everyone past the first 1000 —
 * and because the order is newest-first, the ones dropped are the OLDEST
 * accounts, which is exactly where the admin accounts live. Always page through
 * until a short page comes back instead of guessing a limit.
 */
const PAGE_SIZE = 1000;
const MAX_USERS = 100000; // runaway guard

export async function fetchAllAdminUsers<T = any>(token?: string): Promise<T[]> {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  const all: T[] = [];

  for (let skip = 0; skip < MAX_USERS; skip += PAGE_SIZE) {
    const response = await axios.get(
      `${API_URL}/admin/users?skip=${skip}&limit=${PAGE_SIZE}`,
      { headers }
    );
    const page: T[] = Array.isArray(response.data) ? response.data : [];
    all.push(...page);

    // A page shorter than the limit means we reached the end.
    if (page.length < PAGE_SIZE) break;
  }

  return all;
}
